import { GetJobStatusListResult } from '../data/useGetJobStatusList';
import { SEARCH_TASKS_ARGS_KEY } from '../data/useUpdateTask';
import { getJobStatusNumber, getTaskStatusNumber } from '../globals';
import { SearchJobsWithTasksQueryVariables } from '../data/useSearchJobsWithTasks';
import type { SearchTasksQueryVariables } from '../data/useSearchTasks';
import type { SearchJobsQueryVariables } from '../data/useSearchJobs';
import { JobStatusEnumValueType } from '../components/job/types/job-status-enum';
import { TaskStatusEnumValue } from '../components/work/types/task-status-enum';

export interface QuerySearchJobsArgs
  extends Omit<SearchJobsQueryVariables, 'statuses'> {
  statuses?: JobStatusEnumValueType[];
}

// this should not go in the TYPES folder, but I want a utility function for this
export function searchJobsArgsToGqlSearchJobsArgs(
  input: QuerySearchJobsArgs,
  visibleJobStatuses: GetJobStatusListResult[]
): SearchJobsWithTasksQueryVariables {
  // Due to WORKFLOW-211 and the removing of the closed status from the filter dropdown, this is a lie
  // If the user has not said they want particular statuses, pretend like they picked all the visible ones
  const hasSomeTypeOfStatusSpecified =
    (input.statuses && input.statuses.length > 0) ||
    (input.statusIds && input.statusIds.length > 0);

  const effectiveStatusIds = hasSomeTypeOfStatusSpecified
    ? input.statusIds
    : visibleJobStatuses.map((x) => x.cloudId);

  const statuses = input.statuses?.map((x) => getJobStatusNumber(x));

  return {
    ...input,
    ...(statuses && { statuses }),
    ...(effectiveStatusIds && { statusIds: effectiveStatusIds }),
  } as SearchJobsWithTasksQueryVariables;
}

export interface QuerySearchTasksArgs
  extends Omit<SearchTasksQueryVariables, 'statuses'> {
  statuses?: TaskStatusEnumValue[] | null;
}

export function searchTasksArgsToGqlSearchTasksArgs(
  input: QuerySearchTasksArgs
): SearchTasksQueryVariables {
  const res = {
    ...input,
    statuses: input.statuses?.map((status) => getTaskStatusNumber(status)),
  };

  window.localStorage.setItem(SEARCH_TASKS_ARGS_KEY, JSON.stringify(res));

  return res as SearchTasksQueryVariables;
}
